import { parseISO, format } from 'date-fns';

function formatDate(isoString) {
    const date = parseISO(isoString);
    return format(date, 'dd/MM/yyyy');
}

export default formatDate;

